import * as React from 'react';
import classnames from 'classnames';

export const NoDataAvailable = ({ className }: { className?: string }) => {
  return <small className={classnames('d-block pb-md-0 pt-md-0 pt-4 pb-4', className)}>No Data Available</small>;
};
